/*----------------------------------
- DEPENDANCES
----------------------------------*/

import React from 'react';
import { Linkedin } from 'lucide-preact';

/*----------------------------------
- APP
----------------------------------*/

import {
    MARKETING_FOOTER_GROUPS,
    MARKETING_LOGO_URL,
    MARKETING_URLS,
} from '@/client/catalogs/marketing/navigation';

/*----------------------------------
- TYPES
----------------------------------*/

export interface PublicFooterProps {
    tagline?: string;
}

/*----------------------------------
- COMPONENT
----------------------------------*/

export default function PublicFooter({
    tagline = 'The intelligent operating system for modern recruiters.',
}: PublicFooterProps) {
    return (
        <footer className="py-16 px-6 lg:px-8 bg-gradient-to-br from-orange-50 to-pink-50">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <img src={MARKETING_LOGO_URL} alt="CrossPath Logo" className="w-10 h-10" />
                            <span className="text-xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">
                                CrossPath
                            </span>
                        </div>
                        <p className="text-slate-700 text-sm">{tagline}</p>
                    </div>

                    {MARKETING_FOOTER_GROUPS.map((group) => (
                        <div key={group.title}>
                            <h4 className="font-bold text-slate-900 mb-4">{group.title}</h4>
                            <ul className="space-y-2 text-sm">
                                {group.links.map((link) => (
                                    <li key={link.href}>
                                        <a
                                            href={link.href}
                                            className="text-slate-600 hover:text-orange-600 transition-colors"
                                        >
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="border-t border-orange-200 pt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-sm text-slate-600">© CrossPath 2026. All rights reserved.</p>
                    <a
                        href={MARKETING_URLS.linkedin}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-2 text-slate-600 hover:text-pink-600 transition-colors text-sm"
                    >
                        <Linkedin size={18} />
                        LinkedIn
                    </a>
                </div>
            </div>
        </footer>
    );
}
